module.exports = __webpack_public_path__ + "img/avatar-jake.bba2a26c.jpg";